import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../atoms/icon-inline/nn-icon-inline.js';
/**
 * A component based on a link around icon-inline atom.
 *
 * textLink - The link text content used as title of link and as default slot text in icon-inline atom.
 * hrefLink - The href definition of the component.
 * idLink - The unique id definition.
 * icon - The icon slot definition for icon-inline atom.
 * text - The text slot definition for icon-inline atom.
 * customClass - Custom class for specific rendering. (optional)
 */
@customElement('nn-link')
export class Link extends LitElement {
  static styles = css`
    a,
    a:hover,
    a:active,
    a:focus,
    a:visited {
      text-decoration: none;
    }
  `;

  @property({ type: String }) textLink = 'The default title';

  @property({ type: String }) hrefLink = '#';

  @property({ type: String }) idLink = 'link-id';

  @property({ type: String }) customClass = '';

  render() {
    return html`
      <a
        id="${this.idLink}"
        class="anchor"
        href="${this.hrefLink}"
        title="${this.textLink}"
      >
        <nn-icon-inline class="${this.customClass}">
          <slot slot="icon" name="icon"></slot>
          <slot slot="text" name="text"></slot>
        </nn-icon-inline>
      </a>
    `;
  }
}
